import { FormControl, Validators } from '@angular/forms';
import { EoCustomControlConfig,  EoFormPanelConfig, EoTextAreaConfig } from 'ngx-eo-web-components';

export const surgeryCancelFormPanel = new EoFormPanelConfig({
  name: 'surgeryCancelForm',
  panelContentStyleClass: 'grid',
  config: [
    new EoCustomControlConfig({
      name: 'surgeryCancelReasonOptionID',
      label: 'Αιτιολογία Ακύρωσης',
      styleClass: 'col-12',
      control: new FormControl(null, [Validators.required])
    }),
    new EoTextAreaConfig({
      name: 'surgeryCancelComments',
      styleClass: 'col-12',
      type: 'textarea',
      label: 'Σχόλια Ακύρωσης',
      placeholder: 'Συμπληρώστε σχόλια ακύρωσης',
      rows: 3,
      cols: 30,
      control: new FormControl('', []),
    }),
  ],
});

export const surgeryCancelFormConfig: EoFormPanelConfig[] = [
  surgeryCancelFormPanel,
];

